module.exports = __webpack_public_path__ + "static/img/Frame(19).f43563de.png";